import { createContext } from 'react';
import LoginService from './LoginService';

const LoginContext = createContext<LoginService>(new LoginService());
export default LoginContext;
